import { ResponseMessage } from "../ResponseMessage";


//import java.util.Locale;

export abstract class T1099Response extends ResponseMessage {
}
